// Single source of truth for business details used on About / Contact / Privacy / Terms / Refunds.
// Update the ABN here once registered — every page and the prerenderer read from this file.
export const COMPANY = {
  tradingName: "WanderlyMe",
  operator: "Gurman Soni",
  operatorRole: "Founder & sole trader",
  location: "Sydney, Australia",
  abn: "40 806 560 432",
  abnRaw: "40806560432",
  email: "hello@wanderlyme.com",
  governingLaw: "New South Wales, Australia",
  site: "https://wanderlyme.com",
  founderPhoto: "",
  founderPhotoAlt: "Gurman Soni, founder of WanderlyMe, Sydney",
  legalUpdated: "2026-10-01",
};
